import request from '@utils/request'

export function fetchList(params) {
  return request({
    url: '/admin/member',
    method: 'get',
    params,
  })
}

export function fetchLoginLogList(params) {
  return request({
    url: '/admin/member/login/log',
    method: 'get',
    params,
  })
}

export function fetchInviteRelationList(params) {
  return request({
    url: '/admin/member/invite-relation',
    method: 'get',
    params,
  })
}

export function fetchMember(member_seq) {
  return request.get(`/admin/member/${member_seq}`)
}

export function createMember(data) {
  return request.post('/admin/member', data)
}

export function updateMember({ seq, ...data }) {
  return request.put(`/admin/member/${seq}`, data)
}

export function deleteMember(member_seq) {
  return request.delete(`/admin/member/${member_seq}`)
}

export function fetchGroups() {
  return request({
    url: '/admin/member/group',
    method: 'get',
  })
}

/* deprecated */
export function fetchGroupList() {
  return fetchGroups()
}

export function fetchGroup(seq) {
  return request({
    url: `/admin/member/group/${seq || 0}`,
    method: 'get',
  })
}

export function createGroup(data) {
  return request.post('/admin/member/group', data)
}

export function updateGroup(data) {
  return request.put(`/admin/member/group/${data.seq}`, data)
}

export function deleteGroup(seq) {
  return request.delete(`/admin/member/group/${seq}`)
}

export function fetchGroupMember(member_seq) {
  return request({
    url: `/admin/member/${member_seq || 0}/group`,
    method: 'get',
  })
}

export function createGroupMember({ member_seq, ...data }) {
  return request.post(`/admin/member/${member_seq || 0}/group`, data)
}

export function deleteGroupMember(member_seq, seq) {
  return request.delete(`/admin/member/${member_seq || 0}/group/${seq || 0}`)
}
